import { render, staticRenderFns } from "./EditableItemsDropdown.vue?vue&type=template&id=5f4c56a8&scoped=true&"
import script from "./EditableItemsDropdown.vue?vue&type=script&lang=js&"
export * from "./EditableItemsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./EditableItemsDropdown.vue?vue&type=style&index=0&id=5f4c56a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4c56a8",
  null
  
)

export default component.exports